var domain = 'ui-kit';
var subdomain = 'common';

export default (function (t) {
  return function (token) {
    return t(domain, subdomain)(token);
  };
});